import { useSafeAreaInsets } from "react-native-safe-area-context";
import Box from "../../Box";
import ScrollContainer from "../../ScrollContainer";
import ReportCardsContainer from "../../SessionReport/ReportCardsContainer";
import CardSkeleton from "../CardSkeleton";
import { SuggestedActionsChipsSkeleton } from "../SuggestedActionsChipsSkeleton";
import { SummaryCardSkeleton } from "../SummaryCardSkeleton";

type Props = {
	isSummativeTest?: boolean;
	showScoreRanges?: boolean;
	numScoreRanges?: number;
};

const ReportSkeleton = ({
	isSummativeTest,
	showScoreRanges,
	numScoreRanges,
}: Props) => {
	const insets = useSafeAreaInsets();

	const skeletonCards = [
		<SummaryCardSkeleton
			key="summary-skeleton"
			showScoreRanges={showScoreRanges}
			numScoreRanges={numScoreRanges}
		/>,
		<Box key="suggested-actions-skeleton-container" paddingTop={16}>
			<SuggestedActionsChipsSkeleton
				key="suggested-actions-skeleton"
				height={28}
			/>
		</Box>,
		<CardSkeleton key="performance-skeleton" numRows={5} />,
		<CardSkeleton key="items-skeleton" numRows={3} />,
		<CardSkeleton key="mastery-skeleton" numRows={4} />,
	];

	return (
		<>
			<ScrollContainer
				contentContainerStyle={{
					paddingTop: isSummativeTest ? 84 : 58,
					paddingBottom: 88 + insets.bottom,
					paddingHorizontal: 16,
					gap: 16,
				}}
			>
				<ReportCardsContainer cards={skeletonCards} />
			</ScrollContainer>
		</>
	);
};

export default ReportSkeleton;
